import React from 'react';

const BackgroundPattern = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden">
      {/* Base Background */}
      <div className="absolute inset-0 bg-background"></div>
      
      {/* Heritage Pattern Overlay */}
      <div className="absolute inset-0 opacity-5">
        <svg width="100%" height="100%" className="absolute inset-0">
          <defs>
            <pattern
              id="heritage-pattern"
              x="0"
              y="0"
              width="120"
              height="120"
              patternUnits="userSpaceOnUse"
            >
              {/* Crown motifs */}
              <g fill="var(--color-primary)">
                <path d="M20 30l8 16h24l8-16-8-8-8 8-8-8z" opacity="0.3" />
                <circle cx="28" cy="22" r="2" />
                <circle cx="40" cy="18" r="2" />
                <circle cx="52" cy="22" r="2" />
              </g>
              
              {/* Decorative lines */}
              <g stroke="var(--color-secondary)" strokeWidth="1" opacity="0.2">
                <line x1="0" y1="60" x2="120" y2="60" />
                <line x1="60" y1="0" x2="60" y2="120" />
              </g>
              
              {/* Corner ornaments */}
              <g fill="var(--color-accent)" opacity="0.1">
                <circle cx="10" cy="10" r="3" />
                <circle cx="110" cy="10" r="3" />
                <circle cx="10" cy="110" r="3" />
                <circle cx="110" cy="110" r="3" />
              </g>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#heritage-pattern)" />
        </svg>
      </div>
      
      {/* Gradient Overlays */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent"></div>
      
      {/* Floating Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-primary/5 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-secondary/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-accent/5 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '4s' }}></div>
    </div>
  );
};

export default BackgroundPattern;